import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    excludedHouseIdsCount: number;
    onManageExclusionsClick: () => void;
};

export const PreferencesFiltersMain = ({ excludedHouseIdsCount, onManageExclusionsClick }: Props) => {
    return (
        <div className="flex flex-col gap-sm border-b border-border-primary px-sm pb-md">
            <div>
                <div className="flex items-center justify-between pb-2xs">
                    <H5>
                        <FormattedMessage id="excludeAuctionHousesFilter.chip.title" />
                    </H5>
                    <H5 className="text-text-secondary">({excludedHouseIdsCount})</H5>
                </div>
                <div className="w-full">
                    <BodySecondary className="flex w-full text-text-secondary">
                        <FormattedMessage id="preferencesDrawer.excludeAuctionHouses.subtitle" />
                    </BodySecondary>
                </div>
            </div>
            <Button
                className="w-full"
                onClick={onManageExclusionsClick}
                variant="outlined"
            >
                <FormattedMessage id="preferencesDrawer.excludeAuctionHouses.actionButton" />
            </Button>
        </div>
    );
};
